/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import { Typography } from '@mui/material';
import ArgosFlexbox from '../Containers/ArgosFlexbox';

interface SensorsEmptyTextProps {
    hasWriteAccess: boolean;
    wizardButton: React.ReactNode;
}

/**
 * SensorsEmptyText displays a message indicating that no data has been uploaded for a sensor.
 * If the user has write access, it also prompts the user to upload the completed template and displays a wizard button.
 *
 * @param {SensorsEmptyTextProps} props - The properties passed to the component.
 * @param {boolean} props.hasWriteAccess - A flag indicating whether the user has write access.
 * @param {React.ReactNode} props.wizardButton - A React node representing the wizard button to be displayed if the user has write access.
 *
 * @returns {JSX.Element} The rendered component.
 */
const SensorsEmptyText: React.FC<SensorsEmptyTextProps> = ({ hasWriteAccess, wizardButton }: SensorsEmptyTextProps): JSX.Element => {
    return (
        <ArgosFlexbox>
            <Typography style={{ alignSelf: "center" }} fontSize="18px">No data has been uploaded for this sensor.</Typography>
            { hasWriteAccess ?
                <ArgosFlexbox>
                    <Typography style={{ alignSelf: "center" }} fontSize="18px">Please click the wizard icon to upload the completed template</Typography>
                    {wizardButton}
                </ArgosFlexbox> : ""
            }
        </ArgosFlexbox>
    );
};

export default SensorsEmptyText;